export class CloudfrontService {
  /**
   * Checks if the given url is a CloudFront URL matching to enable Checksum's interactions.
   *
   * @param {string} url - The URL to check.
   * @returns {boolean} - Returns `true` if the url matches the CloudFront checksum pattern, otherwise `false`.
   */
  public static isCloudfrontUrl(url: string): boolean {
    try {
      const parsedUrl = new URL(url);
      const allowedHost = 'd3t0vyzb3ndf7j.cloudfront.net';
      return parsedUrl.host === allowedHost;
    } catch (e) {
      console.error('Invalid URL:', e);
      return false;
    }
  }
}
